import { Card, Tabs } from "@shopify/polaris"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../../actions"
import BiS from "../../../pages/BiSPage"
import GeneralPage from "../../../pages/GeneralPage"
import Plan from "../../../pages/Plan"
import ReminderEmail from "../../../pages/ReminderEmailPage"
import Support from "../../../pages/Support"
import SingleProduct from "../../../pages/SingleProductPage"
import MultipleProductPage from "../../../pages/MultipleProductPage"
function mapStateToProps(state) {
    return {
        store: state,
        pre_order_pages: state.pre_order_pages,
        widgets: state.widgets,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

const INITIAL_STATE = {}

class AppBodyPreOrder extends Component {
    constructor(props) {
        super(props)
        this.state = Object.assign({}, INITIAL_STATE)
    }

    componentDidMount() {
        // this.initAppData();
    }

    handleTabChange = (index: number): void => {
        const { actions } = this.props
        if (index != 1) {
            actions.switchPreOrderPagesAction(index)
        } else {
            window.open(
                `https://${shopOrigin}/admin/orders?selectedView=all&tag=pre-order`,
                "_blank",
            )
        }
    }

    renderComponent = () => {
        const { pre_order_pages } = this.props
        console.log("test", shopOrigin)
        switch (pre_order_pages.selected) {
            case 0:
                return <SingleProduct />

            // case 1:
            //     return <MultipleProductPage />

            case 1:
                break
            // case 3:
            //     return <BiS />

            // case 4:
            //     return <ReminderEmail />

            // case 5:
            //     return <Plan />

            // case 6:
            //     return <Support />
            default:
                return <SingleProduct />
        }
    }

    render() {
        const { pre_order_pages } = this.props
        const disableStyle =
            this.props.plan.plan == "free" ? { opacity: 0.5, pointerEvents: "none" } : {}
        return (
            <div className="body-plan-pro">
                <div className="yta-body" style={disableStyle}>
                    <div className="yta-header2">
                        <div className="header-tabs-block">
                            <Card>
                                <Tabs
                                    tabs={pre_order_pages.data}
                                    selected={
                                        pre_order_pages.selected != 1 && pre_order_pages.selected
                                    }
                                    onSelect={(index) => this.handleTabChange(index)}
                                />
                            </Card>
                        </div>
                    </div>

                    <div className="arn-pre-order main-body">
                        <Card>
                            <Card.Section>{this.renderComponent()}</Card.Section>
                        </Card>
                    </div>
                </div>
                {this.props.plan.plan == "free" && (
                    <span className="tooltiptext">Please upgrade to use this feature</span>
                )}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppBodyPreOrder)
